import { FONT, MEDIA } from "@/styles/common";
import { Divider, Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { PriceProps } from "./price.type";

export const Price = ({ period, basicManCount, person, pay_basic, pay_all_total }: PriceProps) => {
    const { adult, child } = person;
    const { isMobile } = MEDIA();

    const addPeople = adult + child - Number(basicManCount);

    return (
        <CustomFlex
            w={isMobile ? "100%" : "280px"}
            isMobile={isMobile}
            p={isMobile ? "16px" : "0 16px"}
            height="100%"
            alignItems="flex-end"
        >
            <Flex width="100%" flexDir={"column"} rowGap={isMobile ? "16px" : "8px"}>
                <Flex alignItems="center" width="100%" justifyContent="space-between">
                    <CommonText>
                        {period}박 {period + 1}일
                    </CommonText>
                    <Flex alignItems="center" gap="4px">
                        <Text fontSize="24px">{pay_basic.toLocaleString()}</Text>
                        <Text>원</Text>
                    </Flex>
                </Flex>
                {isMobile && <CustomDivider />}
                <Flex alignItems="center" width="100%" justifyContent="space-between">
                    <CommonText>추가인원 {addPeople}인</CommonText>
                    <Flex alignItems="center" gap="4px">
                        <Text fontSize="24px">{(pay_all_total - pay_basic).toLocaleString()}</Text>
                        <Text>원</Text>
                    </Flex>
                </Flex>
                {isMobile && <CustomDivider />}
                <Flex alignItems="center" width="100%" justifyContent="space-between">
                    <CommonText>합계</CommonText>
                    <Flex alignItems="center" gap="4px">
                        <Text fontSize="24px">{pay_all_total.toLocaleString()}</Text>
                        <Text>원</Text>
                    </Flex>
                </Flex>
            </Flex>
        </CustomFlex>
    );
};

const CustomFlex = styled(Flex)<{ isMobile: boolean }>`
    border: ${({ isMobile, theme }) => (isMobile ? `1px solid ${theme.COLOR.gray[300]}` : "none")};
    border-radius: ${({ isMobile }) => (isMobile ? "8px" : "auto")};
`;

const CommonText = styled(Text)`
    ${FONT("pretendard", 16, 500)}
`;

const CustomDivider = styled(Divider)`
    color: ${({ theme }) => theme.COLOR.gray[300]};
`;
